import { routes as notificationPreferenceRoutes } from './notification-preference'

export const routes = {
  ...notificationPreferenceRoutes,
}
